import type { Address as FhirAddress } from '@medplum/fhirtypes'
import { z } from 'zod'

export const addressSchema = z.object({
  address_line1: z.string().max(200),
  address_line2: z.string().max(35).optional().nullable(),
  city: z.string().max(50),
  state: z.string().max(2),
  zip: z.string().max(9), // Assuming zip as a string to preserve leading zeros, if any.
})

export type Address = z.infer<typeof addressSchema>

export function toFhir(
  address: Address | null | undefined,
  use?: FhirAddress['use']
): FhirAddress {
  if (address === null || address === undefined) {
    return {}
  }

  const result: FhirAddress = {}
  result.line = []
  if (address.address_line1) {
    result.line.push(address.address_line1)
  }
  if (address.address_line2) {
    result.line.push(address.address_line2)
  }
  result.city = address.city
  result.state = address.state
  result.postalCode = address.zip
  if (use) {
    result.use = use
  }
  return result
}

export function fromFhir(
  address: FhirAddress | null | undefined
): Address | null {
  if (address === null || address === undefined) {
    return null
  }

  return {
    address_line1: address.line?.[0] ?? '',
    address_line2: address.line?.[1] ?? '',
    city: address.city ?? '',
    state: address.state ?? '',
    zip: address.postalCode ?? '',
  }
}
